import "../scss/styles.scss";
import PageDefault from "./pages/PageDefault.js";

export default class FactoryManager {

	static factory(cls, ...rest) {
		return new FactoryManager.classes[cls](rest[0]);
	}

}

FactoryManager.classes = { PageDefault }; 